export enum ShortcutProductType {
  AA = 'AA',
  DoC = 'DoC',
  KE = 'KE',
  SR = 'SR',
  TL = 'TL',
}
